import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent, Loader as LoaderLayoutComponent, Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  padding-top: 100px;
`;

const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    width: 650px;
    margin-left: auto;
    margin-right: auto;
    padding: 30px;
  }
`;

const Text = styled(TextLayoutComponent)``;

const Instruction = styled(TextLayoutComponent)`
  margin-bottom: 5px;
`;

const Header = styled(TextLayoutComponent)`
  margin-bottom: 20px;
`;

const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 30px 0 10px 0;
`;

const InputContainer = styled.div`
  flex: 4;
  padding: 0 20px 0 20px;
  width: 185px;
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin: 40px auto 0;
    display: block;
  }
`;

const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

const Message = styled(TextLayoutComponent)`
  margin-bottom: 40px;
  font-size: 18px;
  text-align: center;
`;

export {
  Container,
  Segment,
  Text,
  Header,
  FieldContainer,
  InputContainer,
  Button,
  Loader,
  Message,
  Instruction,
};
